import { initAtsStages } from "./ats_stages";
import { bindBoard, initBoardActions } from "./board";
import { initDatePicker } from "./date_picker";
import { initDrawer, openDrawer } from "./drawer";
import { bindList, initListActions } from "./list";
import { initNextAction } from "./next_action";
import { initPopovers } from "./popovers";
import { onViewReplaced, pipelineRoot } from "./request";
import { initStagesModal } from "./stages_modal";

let started = false;

function bindView(root: HTMLElement | null): void {
  bindBoard(root);
  bindList(root);
}

export function initPipeline(): void {
  if (started) return;
  started = true;
  initPopovers();
  initDrawer();
  initNextAction();
  initDatePicker();
  initBoardActions((card) => void openDrawer(card));
  initListActions();
  initStagesModal();
  initAtsStages();
  onViewReplaced((root) => bindView(root));
  document.addEventListener("turbo:load", () => bindView(pipelineRoot()));
  if (document.readyState !== "loading") bindView(pipelineRoot());
}
